import { render } from "./AdminFilms.vue?vue&type=template&id=dec80c86"
import script from "./AdminFilms.vue?vue&type=script&lang=js"
export * from "./AdminFilms.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__